<div class="w-100-p padding-10-lr padding-12-b scroll-y h-60">
  <div class="clr-row nxm h-100">
    <div class="clr-col-lg-4 h-100 padding-1-tb">
      <div class="card item-table">
        <div class="card-header np clr-row nxm clr-align-items-baseline">
          <div class="clr-col-auto margin-12-t margin-12-l nxp">
            {{ 'Zuordnung' | mrTranslate }}
          </div>
          <div class="clr-col clr-form-horizontal width100 clr-row nxm">
            <clr-select-container class="widthAuto margin-0-t clr-col-12">
              <label class="clr-col-auto">{{ 'Fehlerklasse' | mrTranslate }}</label>
              <select
                class="clr-col"
                clrSelect
                name="fk"
                [disabled]="!selectedBaumNode"
                [(ngModel)]="selectedFK"
                [ngModelOptions]="{ standalone: true }">
                @for (fk of rangeFK; track $index) {
                  <option [ngValue]="+fk">{{ fk }}</option>
                }
              </select>
            </clr-select-container>
          </div>
        </div>
        <div class="card-block scroll-y" #treeContainer>
          <clr-tree>
            @for (art of baumTree() | keyvalue; track art.key) {
              <clr-tree-node class="basealign" [clrExpanded]="true">
                <span class="badge badge-light-blue">{{ art.value.length }}</span>
                <span class="clr-col nxp">{{ art.value[0].artName }}</span>
                @for (wartung of art.value; track wartung.ID) {
                  <clr-tree-node
                    id="w-{{ wartung.ID }}"
                    (click)="selectedBaumNode = wartung"
                    class="datagrid-row cursor-pointer"
                    [class.datagrid-selected]="selectedBaumNode == wartung">
                      <cds-icon shape="wrench" size="18" />
                      <span>
                        {{ wartung.arbeitName }}
                      </span>
                  </clr-tree-node>
                }
              </clr-tree-node>
            }
          </clr-tree>
        </div>
        <div class="card-footer d-f clr-justify-content-between">
          <div class="btn-group btn-primary btn-icon">
            <button
              class="btn btn-icon margin-12-l"
              [title]="'Speichern' | mrTranslate"
              (click)="saveBaumNode()"
              [disabled]="!selectedBaumNode">
              <cds-icon shape="floppy" />
            </button>
            <button
              class="btn btn-icon btn-danger"
              [title]="'Löschen' | mrTranslate"
              (click)="deleteBaumNode()"
              [disabled]="!selectedBaumNode || setInsert()">
              <cds-icon shape="times" />
            </button>
            <button
              class="btn btn-icon btn-success"
              [title]="'Neu' | mrTranslate"
              (click)="addBaumNode()"
              [disabled]="setInsert()">
              <cds-icon shape="file" />
            </button>
          </div>

          {{ baumTree()?.size }} {{ 'Verknüpfungen' | mrTranslate }}
        </div>
      </div>
    </div>
    <div class="clr-col-lg-8 h-100 half-cards">
      <div>
        <app-wartungsitem
          #art
          [otypid]="otypid()"
          [mode]="'art'"
          [withHelper]="true"
          (editedItem)="editTree('art', $event)"
          (deletedItem)="cleanTree('art', $event)" />
      </div>
      <div>
        <app-wartungsitem
          #arbeit
          [otypid]="otypid()"
          [mode]="'arbeit'"
          (editedItem)="editTree('arbeit', $event)"
          (deletedItem)="cleanTree('arbeit', $event)" />
      </div>
    </div>
  </div>
</div>
